export const DEFAULT_TIERS = [
  { units: 5, discount: 25 },
  { units: 10, discount: 50 },
  { units: 20, discount: 100 },
];

export const DEFAULT_VARIANTS = [
  { label: "1 unit", price: 0, delivery_fee: 50, enabled: true },
  { label: "1/2 unit", price: 0, delivery_fee: 25, enabled: true },
  { label: "1/4 unit", price: 0, delivery_fee: 25, enabled: true },
  { label: "1 zip", price: 0, delivery_fee: 25, enabled: true },
];

export function productVariants(p) {
  return (p.variants || []).filter((v) => v.enabled !== false);
}

export function hasVariants(p) {
  return productVariants(p).length > 0;
}

export function unitPriceFor(p, variant) {
  if (variant && variant.price != null) return Number(variant.price);
  return effectivePrice(p);
}

export function variantDeliveryFee(variant, defaultFee) {
  if (variant && variant.delivery_fee != null && variant.delivery_fee !== "") return Number(variant.delivery_fee);
  return Number(defaultFee || 0);
}

export function itemDeliveryFee(product, variant, defaultFee) {
  if (variant && variant.delivery_fee != null && variant.delivery_fee !== "") return Number(variant.delivery_fee);
  if (product && product.delivery_fee != null && product.delivery_fee !== "") return Number(product.delivery_fee);
  return Number(defaultFee || 0);
}

export function cartKey(productId, variantLabel) {
  return `${productId}::${variantLabel || "default"}`;
}

export function effectivePrice(p) {
  if (p.hot_steal && p.sale_price != null) return Number(p.sale_price);
  return Number(p.price || 0);
}

export function unitDiscount(qty, tiers) {
  const t = [...(tiers && tiers.length ? tiers : DEFAULT_TIERS)].sort((a, b) => a.units - b.units);
  let disc = 0;
  for (const tier of t) if (qty >= Number(tier.units)) disc = Number(tier.discount);
  return disc;
}

export function nextTierHint(qty, tiers, currentDisc) {
  const t = [...(tiers && tiers.length ? tiers : DEFAULT_TIERS)].sort((a, b) => a.units - b.units);
  for (const tier of t) {
    if (qty < Number(tier.units)) {
      return { add: Number(tier.units) - qty, save: Number(tier.discount) };
    }
  }
  return null;
}

// items: [{ product, qty, variant }]
export function computeTotals(items, { fulfillment, deliveryFee, feePct }) {
  let subtotal = 0;
  let bundle = 0;
  let maxDelivery = 0;
  for (const { product, qty, variant } of items) {
    const price = unitPriceFor(product, variant);
    const ud = unitDiscount(qty, product.tiers);
    subtotal += price * qty;
    bundle += ud * qty;
    maxDelivery = Math.max(maxDelivery, itemDeliveryFee(product, variant, deliveryFee));
  }
  const discounted = subtotal - bundle;
  const delivery = fulfillment === "delivery" ? maxDelivery : 0;
  const payFee = feePct != null ? Math.round((discounted + delivery) * feePct) / 100 : 0;
  const total = discounted + delivery + payFee;
  return {
    subtotal: round2(subtotal),
    bundle_discount: round2(bundle),
    delivery_fee: round2(delivery),
    payment_fee: round2(payFee),
    total: round2(total),
  };
}

export function round2(n) {
  return Math.round((n + Number.EPSILON) * 100) / 100;
}

export function money(n) {
  return `$${round2(Number(n || 0)).toFixed(2)}`;
}
